var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{class:[
        _vm.defaultType,
        'ad-banner-wrap',
        _vm.advList.length <= 1 ? 'one-banner' : '',
    ],attrs:{"height":_vm.height,"loop":true}},[(_vm.advList.length > 0)?_vm._l((_vm.advList),function(advInfo){return _c('el-carousel-item',{key:advInfo.image},[_c('div',{class:[_vm.defaultType, 'adv-box']},[(advInfo.url)?_c('a',{staticClass:"link",style:({
                        backgroundImage: 'url(' + advInfo.image + ')',
                    }),attrs:{"target":"_blank","href":advInfo.url}}):_c('a',{staticClass:"link no-pointer",style:({
                        backgroundImage: 'url(' + advInfo.image + ')',
                    }),attrs:{"href":"javascript:void(0)"}})])])}):[_c('el-carousel-item',[_c('div',{class:[_vm.defaultType, 'adv-box']},[_c('a',{class:[_vm.defaultType, 'link'],attrs:{"href":"javascript:void(0)"},on:{"click":_vm.toContactUs}})])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }